import { useState } from 'react';

import { ComponentRefModel } from '../../Models/ComponentRefModel';
import { ComponentInputDialog } from './ComponentInputDialog';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';

type ComponentInputProps = {
	componentRef: ComponentRefModel | undefined;
	onComponentRefChange: (componentRef: ComponentRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function ComponentInput({ componentRef, onComponentRefChange, isEditable = true }: ComponentInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={componentRef} />;
	}

	return (
		<GenericPropertyInput value={componentRef} onValueChange={onComponentRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={componentRef} />
			{open && <ComponentInputDialog open={open} setOpen={setOpen} componentRef={componentRef} onComponentRefChange={onComponentRefChange} />}
		</GenericPropertyInput>
	);
}
